import { render, staticRenderFns } from "./zyCoupon.vue?vue&type=template&id=bc3cdc68&scoped=true&"
import script from "./zyCoupon.vue?vue&type=script&lang=js&"
export * from "./zyCoupon.vue?vue&type=script&lang=js&"
import style0 from "./zyCoupon.vue?vue&type=style&index=0&id=bc3cdc68&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc3cdc68",
  null
  
)

export default component.exports